// extracted by mini-css-extract-plugin
export default {"tooltip-container":"J_snR_i","tooltip-text":"IHr0USo","visible":"SGPPN9X","tooltip-arrow-top":"ERUYAUd","tooltip-arrow-bottom":"cdfDUwf","tooltip-text-wrapper":"nCDw3xV"};